import { Instance } from 'mobx-state-tree';
import { ProjectRouteDeletedDtoModelBase } from './ProjectRouteDeletedDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteDeletedDtoModel */
export interface ProjectRouteDeletedDtoModelType extends Instance<typeof ProjectRouteDeletedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteDeletedDtoModel */
export { selectFromProjectRouteDeletedDto, projectRouteDeletedDtoModelPrimitives, ProjectRouteDeletedDtoModelSelector } from './ProjectRouteDeletedDtoModel.base';

/**
 * ProjectRouteDeletedDtoModel
 */
export const ProjectRouteDeletedDtoModel = ProjectRouteDeletedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
